module.exports = __webpack_public_path__ + "static/media/justin_toyama.084afe14.png";